var styles = {"box":"PlayModal_box_10juo_1","row":"PlayModal_row_10juo_6","col":"PlayModal_col_10juo_11","button-full":"PlayModal_button-full_10juo_17","demo":"PlayModal_demo_10juo_35","select-wrapper":"PlayModal_select-wrapper_10juo_38","label":"PlayModal_label_10juo_47"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
